module.exports = __webpack_public_path__ + "img/Aviation_saf_2.58e8d664.jpg";